import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonUnindent
  from 'components/atoms/Editors/EditorMenuButtonUnindent/EditorMenuButtonUnindent.styles';
import {useRichTextEditorContext} from 'mui-tiptap';

const EditorMenuButtonUnindent = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonUnindent');

  const editor = useRichTextEditorContext();
  const canLiftListItem = editor.can().liftListItem('listItem');
  const canLiftTaskItem = editor.can().liftListItem('taskItem');

  return <StyledEditorMenuButtonUnindent buttonRef={ref} {...innerProps}
                                         disabled={!editor?.isEditable || !(canLiftListItem || canLiftTaskItem)}
                                         onClick={() => {
                                           if (canLiftListItem) {
                                            editor?.chain().focus().liftListItem('listItem').run();
                                           } else {
                                             editor?.chain().focus().liftListItem('taskItem').run();
                                           }
                                         }}/>
});

EditorMenuButtonUnindent.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonUnindent;
